import { useApiRead } from "source/shared/SessionApiResource"

export function usePublicPlanDetails({ planId, serviceTypeId, beforeAfter }) {
  let url = ""
  if (planId) {
    url = `/services/v2/public_plans/${planId}`
  } else {
    url = `/services/v2/public_plans?service_type_id=${serviceTypeId}&${beforeAfter}=true`
  }

  const {
    dates,
    public_items,
    errors,
    series_art,
    starts_at,
    service_type_name,
    title,
  } = usePublicPlan({
    url,
  })

  return {
    errors: errors,
    plan: {
      seriesArt: series_art,
      startsAt: starts_at,
      title: title,
      date: dates,
      serviceTypeName: service_type_name,
      planItems: public_items,
    },
  }
}

function usePublicPlan({ url }) {
  const response = useApiRead(url)
  return response.errors ? { errors: true } : response.data.attributes
}
